var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBfcm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f5bfd9d9-e1d4-4c19-aa77-adf936c7ab6c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 236 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a4af404b-672a-4baa-ac97-c625ba850494,.bb354b84-26a2-4ff1-8bdf-58197ecd81db{fill:none;}.e1736466-ee71-49a4-b7ff-f481a1b608a1{clip-path:url(#a15852bc-a2c8-478d-8d78-bf63e613408f);}.af1bfd02-2a67-4dac-a5dc-d7bcbf6363b6{clip-path:url(#ff42059d-036e-4d81-9b1d-65ccceec204d);}.b181f1bf-a432-4b29-a926-7a083901188a{fill:#ffb297;}.b7d9e482-f565-439e-a511-0387c58a9884{clip-path:url(#f2baaf94-7bf4-4e8e-88d6-2a6a2bc60e62);}.a53b7fef-dedc-4e3b-b63b-8ac3a1ba30dc{clip-path:url(#a646c057-d9b2-4898-9a87-42e322d25a85);}.f303674e-8181-44a2-87f6-1c7274276f69{clip-path:url(#b1d1a24e-5ba4-460a-8dbf-9c4ed19ea07a);}.ba430aba-8d38-47bb-aa9a-aa0dc16704c1{clip-path:url(#a55c1a03-4c18-4d9e-af1c-0a3f81c23272);}.bb354b84-26a2-4ff1-8bdf-58197ecd81db{stroke:#fff;stroke-miterlimit:10;stroke-width:4.93px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a15852bc-a2c8-478d-8d78-bf63e613408f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a4af404b-672a-4baa-ac97-c625ba850494",
    width: 236,
    height: 258
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff42059d-036e-4d81-9b1d-65ccceec204d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a4af404b-672a-4baa-ac97-c625ba850494",
    cx: 118,
    cy: 142,
    r: 113
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2baaf94-7bf4-4e8e-88d6-2a6a2bc60e62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4af404b-672a-4baa-ac97-c625ba850494",
    d: "M92.92,92.18c11.18,0,18.51,3.41,18.51,12.92,0,5.23-2.18,8.57-5.74,10.82,5.6,2,9.37,6,9.37,13,0,8.35-5.23,14.08-18.29,14.08H52.7V92.18ZM96.77,122H63.59v10.89H96.77c5.8,0,8.13-1.74,8.13-5.52S102.57,122,96.77,122Zm-3.85-19.6H63.59v9.43H92.92c6.1,0,8.35-1.3,8.35-4.71S99,102.35,92.92,102.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a646c057-d9b2-4898-9a87-42e322d25a85"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "a4af404b-672a-4baa-ac97-c625ba850494",
    points: "181.81 92.18 181.81 102.35 137.6 102.35 137.6 111.78 177.46 111.78 177.46 121.95 137.6 121.95 137.6 143 126.71 143 126.71 92.18 181.81 92.18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1d1a24e-5ba4-460a-8dbf-9c4ed19ea07a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4af404b-672a-4baa-ac97-c625ba850494",
    d: "M84.3,156.59a70.08,70.08,0,0,1,22.86,3.6L105,168.88A73.45,73.45,0,0,0,84.3,165.6c-17,0-23.31,6-23.31,14.49s6.36,14.48,23.31,14.48A73.1,73.1,0,0,0,105,191.29l2.18,8.69a69.69,69.69,0,0,1-22.86,3.61c-23.37,0-33.14-10.11-33.14-23.5S60.93,156.59,84.3,156.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a55c1a03-4c18-4d9e-af1c-0a3f81c23272"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "a4af404b-672a-4baa-ac97-c625ba850494",
    points: "126.84 157.66 149.66 184.79 172.49 157.66 182.16 157.66 182.16 202.66 172.49 202.66 172.49 176.95 172.69 170.46 152.57 194.31 146.7 194.31 126.64 170.46 126.84 176.95 126.84 202.66 117.16 202.66 117.16 157.66 126.84 157.66"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "e1736466-ee71-49a4-b7ff-f481a1b608a1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "af1bfd02-2a67-4dac-a5dc-d7bcbf6363b6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b181f1bf-a432-4b29-a926-7a083901188a",
    points: "5 29 231 29 231 255 5 255 5 29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b7d9e482-f565-439e-a511-0387c58a9884"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "52.7 92.18 115.06 92.18 115.06 143 52.7 143 52.7 92.18"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a53b7fef-dedc-4e3b-b63b-8ac3a1ba30dc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "126.71 92.18 181.81 92.18 181.81 143 126.71 143 126.71 92.18"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f303674e-8181-44a2-87f6-1c7274276f69"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "51.16 156.59 107.16 156.59 107.16 203.59 51.16 203.59 51.16 156.59"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ba430aba-8d38-47bb-aa9a-aa0dc16704c1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "117.16 157.66 182.16 157.66 182.16 202.66 117.16 202.66 117.16 157.66"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bb354b84-26a2-4ff1-8bdf-58197ecd81db",
    d: "M55.5,4V82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb354b84-26a2-4ff1-8bdf-58197ecd81db",
    d: "M27.35,16.05l55.3,54.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb354b84-26a2-4ff1-8bdf-58197ecd81db",
    d: "M16,43l78,.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb354b84-26a2-4ff1-8bdf-58197ecd81db",
    d: "M28.05,71.36,82,14.64"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfcm);
export default __webpack_public_path__ + "static/media/bfcm.46ca52cdd1e2636875ec2cf478ed7d95.svg";
export { ForwardRef as ReactComponent };